<template>
  <CusModal
    @handleCancel="onClose"
    @handleOk="onClickConfirm"
    :title="$t('timeSheets.confirm_unsubmit')"
    :isShow="open"
  >
    <div class="card-modal-infomation">
      <div class="card-modal-warning">
       <img src="/img/icons/warning-icon.svg" alt="" />
        <div class="card-modal-warning-label">
          {{$t("popup.commons.label_confirm_title")}}
        </div>
      </div>
    </div>
  </CusModal>
</template>

<script>
import CusModal from "@/components/commons/CusModal.vue";

export default {
  props: {
    open: {
      type: Boolean,
      // required:true
    },
  },
  components: {
    CusModal,
  },
  methods: {
    onClickConfirm() {
      this.$emit("unsubmitable");
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.card-modal-button {
  margin-left: auto;
  font-size: 18px;
  font-weight: 800;
  line-height: 18px;
}

.card-modal-action {
  text-align: center;
  margin: 10px 0 30px 0;
}

.btn-submit-timesheet {
  width: 200px;
  height: 40px;
  background: #3d4cdc;
  border-radius: 10px;
  color: white;
  border: none;
  font-weight: 700;
  outline: none !important;
}

.btn-cancel-timesheet {
  width: 200px;
  height: 40px;
  background: #ececec;
  border-radius: 10px;
  color: #6f6f6f;
  outline: none !important;
  margin-left: 20px;
  border: none;
  font-weight: 700;
}

.card-modal-warning {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  text-align: center;
  /* margin-top: 15px; */
  display: flex;
  justify-content: center;
}

.card-modal-dayoff {
  display: flex;
  width: 200px;
  margin-left: 242px;
}
.card-modal-calculate {
  margin-top: 20px;
}

.card-modal-dayoff-quantity {
  margin-left: auto;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #8492a6;
}

.card-modal-dayoff-up {
  border-bottom: 1px solid #dde2e5;
}

.label-dayoff {
  color: #118fa6;
  font-weight: 700;
}

.label-missing_timesheet {
  color: #f58722;
  font-weight: 700;
}
.card-modal-dayoff-label {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
}

.card-modal-select {
  width: 200px;
  display: flex;
  line-height: 14px;
  padding: 5px 0px;
}

.card-modal-option {
  margin-left: 250px;
  margin-top: 20px;
}

.card-modal-select input {
  margin-right: 5px;
  font-size: 14px;
}

.card-modal-button {
  cursor: pointer;
}

.card-modal-option-text {
  display: flex;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
}

.input-option {
  width: 25px;
  height: 18px;
  margin: 0px 5px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #dde2e5;
  border-radius: 4px;
  outline: none;
}

.label-dayoff-text {
  margin: 0px 5px;
}

.card-modal-warning-label {
  margin-left: 10px;
  margin-top: 1px;
}
</style>
